/**
 * @todo Удалить файл с экспериментом
 * @description Данный функционал появился в задаче CD-153172, будет удалён в задаче CD-153173
 */

import { createSelector } from 'reselect';

import { isBusinessSale } from '../../utils/commercial';
import { getIsCommercialByOffer } from '../../utils/getIsCommercialByOffer';
import { getIsCoworkingByOffer } from '../../utils/getIsCoworkingByOffer';
import { abUseExperimentsSelector, getIsAbUseExperimentsActiveFactory } from '../abUseExperiments';
import { featureToggleSelector } from '../featureToggle/featureToggleSelector';
import { offerSelector } from '../offerData';

export const COMMERCIAL_UNIQUE_TO_CIAN_EXPERIMENT_V2 = 'commercial_unique_to_cian_experiment_v2';

const getIsAbUseExperimentsActiveFactoryByExperiment = getIsAbUseExperimentsActiveFactory(
  COMMERCIAL_UNIQUE_TO_CIAN_EXPERIMENT_V2,
);

export const isCommercialUniqueToCianExperimentEnabledSelector = createSelector(
  [offerSelector, abUseExperimentsSelector, featureToggleSelector],
  (offer, abUseExperiments, featureToggle): boolean => {
    return (
      featureToggle.isCommercialUniqueToCianV2 &&
      [getIsCommercialByOffer].some(fn => fn(offer)) &&
      ![getIsCoworkingByOffer, isBusinessSale].some(fn => fn(offer)) &&
      getIsAbUseExperimentsActiveFactoryByExperiment('B')(abUseExperiments)
    );
  },
);
